export default {
  active: {
    modal: '',
    tab: '',
    projectId: '',
    dataGroupId: ''
  },
  projects: {},
  breakpoint: ''
}



// WEBPACK FOOTER //
// ./src/store/state.js